module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-polo-uniforme-personalizado.86652094.jpg";